// extracted by mini-css-extract-plugin
export default {"navLinks":"ZWtbo","simple":"hbS1o","navLink":"NH69c","isActive":"dISox"};